class invoiceAnalysisCtrl {
    constructor($scope, httpRequest) {
        httpRequest.post_queryReportUrl(localStorage.defaultKey).then((res) => {
            if (res.data.success) {
                $scope.url = res.data.value.url
            }
        })
    }
}

invoiceAnalysisCtrl.$inject = ['$scope', 'httpRequest']
export default invoiceAnalysisCtrl



// WEBPACK FOOTER //
// ./src/app/statistics/chartAnalysis/stateAnalysis/stateAnalysisCtrl.js